import Layout from "../Frames/Layout";
import Loader from "../Tools/Loader";
import Chapter from "./Plan/Chapter";
import useSections from "./Hooks/useSections";
import useChapters from "./Hooks/useChapters";
import { Add, Visibility } from "@mui/icons-material";
import useCreateChapter from "./Hooks/useCreateChapter";
import { DndContext } from "@dnd-kit/core";
import {restrictToVerticalAxis} from '@dnd-kit/modifiers';
import { Alert, Button, Stack } from "@mui/material";
import useUpdateSection from "./Hooks/useUpdateSection";
import useUpdateChapter from "./Hooks/useUpdateChapter";
import { useState } from "react";
import Droppable from "./Common/Droppable";
import VimeoButton from "./Plan/VimeoButton";
import { Link, useParams } from "react-router-dom";
import Top from "./Common/Top";
import { txt } from "../../services/translation";
import AuditButton from "./Plan/AuditButton";

export default function Plan(){

    const {id} = useParams()

    const [dragged, setDragged] = useState({})

    const chapters = useChapters()
    const sections = useSections()

    const createChapter = useCreateChapter()

    const updateSection = useUpdateSection()
    const updateChapter = useUpdateChapter()
    
    const onDragStart = e => {
        setDragged(e.active?.data?.current);
    }

    const onDragEnd = e => {
        setDragged(null);
        let dragged = {...e.active.data.current};
        let dropped = e.over?.data?.current;
        if(!dropped) return false;
        Object.assign(dragged, dropped);
        return dropped.isSection ? updateSection(dragged) : updateChapter(dragged);
    }

    return <Layout menu='design' tab='plan' style={{background: 'rgb(250,250,250)'}}>

        {id === 'new' ?

            <Alert severity="warning">
                {txt('pleaseFinalize')} <Link to={`/design/${id}`}><u>{txt('creationLinkText')}</u></Link> {txt('editPlanMessage')}
            </Alert>

            :

            (chapters?.isFetching || sections?.isFetching) ? <Loader /> : 

                <DndContext 
                    onDragStart={onDragStart}
                    onDragEnd={onDragEnd} 
                    modifiers={[restrictToVerticalAxis]}
                >

                    <Stack spacing={1} sx={{maxWidth: 1000, margin: 'auto'}}>

                        <Top title={txt('coursePlanTitle')} />

                        <Stack direction='row' justifyContent='space-between' flexWrap='wrap-reverse'>

                            <Button startIcon={<Add />} onClick={() => createChapter(1)}>
                                {txt('chapterButton')}
                            </Button>

                            <Stack direction='row' spacing={1}>

                                <Link to={`/study/${id}`} target='_blank' rel='noopener noreferrer'>
                                    <Button startIcon={<Visibility />}>
                                        {txt('viewButton')}
                                    </Button>
                                </Link>

                                <VimeoButton chapters={chapters} sections={sections} />

                                <AuditButton chapters={chapters} sections={sections} />
                                
                            </Stack>

                        </Stack>


                        <Droppable 
                            id={'chapter0'}
                            data={{rank: 0, isChapter: true}}
                            disabled={!dragged?.isChapter || dragged?.rank === 1}
                        />

                        {chapters.data
                            .sort((a,b) => a.rank - b.rank)
                            .map((c,i) => 
                                <Chapter 
                                    key={c.id} 
                                    data={c}
                                    sections={sections.isSuccess ? 
                                        sections.data.filter(s => s.chapter?.id === c.id) :
                                        []
                                    }
                                    isFirst={i === 0}
                                    isLast={i === chapters.data.length - 1}
                                    dragged={dragged}
                                />    
                            )}

                    </Stack>
                
                </DndContext>
        }
        
        

    </Layout>
    
}